"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.OldPrice = exports.CurrentPrice = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _utils = require("./utils");
const Root = exports.Root = (0, _mui.styled)('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start'
});
const CurrentPrice = exports.CurrentPrice = (0, _mui.styled)(_mui.Typography, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['oldPriceVisible'])
})(({
  oldPriceVisible,
  theme
}) => ({
  color: (0, _utils.getCurrentPriceColor)(theme, oldPriceVisible)
}));
const OldPrice = exports.OldPrice = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.grey.A700,
  textDecoration: 'line-through'
}));
